import {useSyncExternalStore} from 'react'
import {getUploads, subscribeUploads, UploadEntry} from '../../core/uploadTracker'

/** This tab's uploads, newest first; re-renders on every change (uploadTracker). */
export function useUploads(): readonly UploadEntry[] {
  return useSyncExternalStore(subscribeUploads, getUploads)
}
